/**
 * ComfyPanel Shopify Liquid Modules - Shared Language Switcher JS
 * Robust version using Event Delegation & MutationObserver to support
 * standard page loads, local testing, and dynamic/AJAX content loading in Shopify.
 */
(function () {
    // 1. Event Delegation for Click Action
    // This guarantees switcher buttons work even if they are loaded dynamically via AJAX/React.
    document.addEventListener('click', (event) => {
        const btn = event.target.closest('.switcher-btn');
        if (!btn) return;

        const container = btn.closest('.comfypanel-product-section, #comfypanel-policy-section, #comfypanel-tutorial-section');
        if (!container) return;

        const lang = btn.dataset.lang;
        if (!lang) return;

        // Apply language class safely without wiping out other layout class names
        if (container.classList.contains('comfypanel-product-section')) {
            container.classList.remove('lang-en', 'lang-zh');
            container.classList.add(`lang-${lang}`);
        } else {
            // Keep original behavior for policy and tutorial sections (which use className)
            container.className = `lang-${lang}`;
        }

        // Synchronize active states of buttons inside this container
        container.querySelectorAll('.switcher-btn').forEach(b => {
            if (b.dataset.lang === lang) {
                b.classList.add('active');
            } else {
                b.classList.remove('active');
            }
        });
    });

    // 2. Initialize default language based on browser setting
    function applyInitialLanguage() {
        const containers = document.querySelectorAll(
            '.comfypanel-product-section, #comfypanel-policy-section, #comfypanel-tutorial-section'
        );

        containers.forEach(container => {
            if (container.dataset.languageInitialized === "true") return;
            container.dataset.languageInitialized = "true";

            // Detect user language (Default to 'en' if not starting with 'zh')
            const userLang = navigator.language || navigator.userLanguage || 'en';
            const defaultLang = userLang.startsWith('zh') ? 'zh' : 'en';

            if (container.classList.contains('comfypanel-product-section')) {
                container.classList.remove('lang-en', 'lang-zh');
                container.classList.add(`lang-${defaultLang}`);
            } else {
                container.className = `lang-${defaultLang}`;
            }

            // Sync active state of buttons
            container.querySelectorAll('.switcher-btn').forEach(btn => {
                if (btn.dataset.lang === defaultLang) {
                    btn.classList.add('active');
                } else {
                    btn.classList.remove('active');
                }
            });
        });
    }

    // Run immediately when script executes
    applyInitialLanguage();

    // Trigger on DOMContentLoaded for safety
    document.addEventListener('DOMContentLoaded', applyInitialLanguage);

    // 3. Fallback for dynamically injected/lazy-loaded Shopify blocks (AJAX)
    if (window.MutationObserver) {
        const observer = new MutationObserver(() => {
            applyInitialLanguage();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
})();

/**
 * ComfyPanel Sidebar Scrollspy
 */
(function () {
    const navLinks = document.querySelectorAll('.nav-link');
    const sections = document.querySelectorAll('section[id]');
    const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const activeId = entry.target.getAttribute('id');
            
                navLinks.forEach((link) => {
                    link.classList.remove('active');
                    if (link.getAttribute('href') === `#${activeId}`) {
                        link.classList.add('active');
                    }
                });
            }
        });
    }, observerOptions);

    sections.forEach((section) => {
        observer.observe(section);
    });
})();
